<div class="grid-gap-x6">

  <adex-dynamic-form
    (changeForm)="changeForm$.next($event)"
    (validForm)="validForm$.next($event)"
    [model]="model"
  ></adex-dynamic-form>

  <div class="grid-columns-one-to-two-gap-x2">
    <button
      (click)="onSubmit()"
      [disabled]="disabledButton$ | async"
      class="grid-columns-start-tow" nz-button
      nzType="primary"
    >{{'SET_UP_PASSWORD' | translate}}</button>
  </div>

</div>
